import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconNames } from '../../../common/constants/icon-names';

@Component({
  selector: 'lib-tracking-map-card',
  templateUrl: './tracking-map-card.component.html',
  styleUrls: ['./tracking-map-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackingMapCardComponent {
  @Input() title = 'transportOrder.tracking.title';
  iconNames = IconNames;
}
